import React from "react";
import { FiAlertTriangle, FiRefreshCw } from "react-icons/fi";

export default function RechercheErrorState({ onRetry }) {
  return (
    <div className="rounded-[2rem] border border-red-200 bg-red-50 px-6 py-8 text-center shadow-sm dark:border-red-900/60 dark:bg-red-950/30">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-3xl bg-red-100 text-red-700 dark:bg-red-500/10 dark:text-red-300">
        <FiAlertTriangle className="h-6 w-6" />
      </div>

      <h2 className="mt-4 text-xl font-bold text-red-800 dark:text-red-200">
        La recherche a échoué
      </h2>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-7 text-red-700 dark:text-red-300">
        Une erreur est survenue pendant la recherche. Vous pouvez réessayer.
      </p>

      <button
        type="button"
        onClick={onRetry}
        className="mt-5 inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-red-700 px-5 text-sm font-bold text-white transition hover:bg-red-800"
      >
        <FiRefreshCw className="h-4 w-4" />
        Réessayer
      </button>
    </div>
  );
}